import React from 'react';
import Icon from './Icon';

const TechStack = props => {
    const stackItems = props.stack.map(item => <Icon key={item.type} type={item.type} name={item.name} />);
    return(
        <div className="icon">
            <h2 className="icon__heading heading-secondary">Stack</h2>
            <ul className="icon__list">
                {stackItems}
            </ul>
        </div>
    );
}

export default TechStack;


// WEBPACK FOOTER //
// ./src/components/TechStack.js